import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, DestroyRef } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';
import { ShopSearchHelperService } from '../shop-search-helper.service';
import {
  BookingParametersInterface,
  ActioncodeInterface,
  codetype
} from '../../../entities/bookingParameters';
import { PromocodeService } from '../../../../shared/services/promocode.service';
import { TagManagerService } from '../../../../core/services/tag-manager.service';
import { infoCircle, provideIcons } from '../../../icons';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-promotion-code',
  templateUrl: './promotion-code.component.html',
  styleUrls: ['./promotion-code.component.scss'],
  providers: [provideIcons({ infoCircle })]
})
export class PromotionCodeComponent implements OnInit {
  @Input() subFormGroup: FormControl;
  @Input() bookingParameters: BookingParametersInterface;
  @Input() isIncludedOnStart = false;
  @Input() implementationPage: string; // on what page the field is implemented (for analytics)

  /**
   * emits new valid promotioncode as string
   */
  @Output() changedPromotionCode: EventEmitter<string> = new EventEmitter<string>();

  @Output() changedCouponCode: EventEmitter<ActioncodeInterface> = new EventEmitter<ActioncodeInterface>();

  PROMOCODE_DEFAULT = 0;
  PROMOCODE_INVALID = 10;
  PROMOCODE_VALID = 20;
  promocodeState: number; // true if the promocode is valid, false if not or not yet determined
  promocodeSearching: boolean; // true if search request to server is still waiting, false if done

  // private fireEvents = true;
  isChrome = false;

  get promotionCode() {
    return this.subFormGroup;
  }

  constructor(
    public controlContainer: ControlContainer, // allows us to nest this within any form
    private promocodeService: PromocodeService,
    protected shopSearchHelper: ShopSearchHelperService,
    private cdr: ChangeDetectorRef,
    private tagManager: TagManagerService,
    private detroyRef: DestroyRef
  ) {
    this.isChrome = shopSearchHelper.isChrome();
  }

  ngOnInit() {
    if (this.bookingParameters) {
      this.promocodeService.partner = this.bookingParameters.partner;
      const code = this.bookingParameters.codes.find(_code => _code.type === codetype.promo);
      if (code) {
        // set the promocode value on the form
        this.promotionCode.setValue(code.text);
        this.searchPromocode(code.text);
        this.promocodeState = this.PROMOCODE_VALID;
      }
    }
    // check for changes in promocode input
    this.promocodeService.onSearching
      .pipe(takeUntilDestroyed(this.detroyRef))
      .subscribe((search: boolean) => {
        this.promocodeSearching = search;
      });

    this.promocodeService.newCode
      .pipe(takeUntilDestroyed(this.detroyRef))
      .subscribe((code: ActioncodeInterface) => {
        switch (code.type) {
          case codetype.promo:
            if (code.errorCode) {
              this.promocodeState = this.PROMOCODE_INVALID;
              this.tagManager.push({
                gtagType: 'event',
                gtagName: 'select_promotion',
                parameters: {
                  creative_slot: this.implementationPage, // todo: differentiate me
                  promotion_name: code.text,
                  promotion_id: 'promocode_invalid'
                }
              });
            } else {
              this.promocodeState = this.PROMOCODE_VALID;
              this.tagManager.push({
                gtagType: 'event',
                gtagName: 'select_promotion',
                parameters: {
                  creative_slot: this.implementationPage, // todo: differentiate me
                  promotion_name: code.text,
                  promotion_id: 'promocode_valid'
                }
              });
              this.changedPromotionCode.emit(code.text);
            }
            break;
          case codetype.coupon:
            if (code.errorCode) {
              this.promocodeState = this.PROMOCODE_INVALID;
            } else {
              this.promocodeState = this.PROMOCODE_DEFAULT;
              this.promotionCode.setValue('');
              this.changedCouponCode.emit(code);

              // remove all coupon codes, add new coupon code
              if (this.bookingParameters.codes.find(_code => _code.type === codetype.coupon)) {
                this.bookingParameters.codes.forEach((_code, index) => {
                  if (_code.type === codetype.coupon) {
                    this.bookingParameters.codes.splice(index, 1);
                  }
                });
              }
              this.bookingParameters.codes.push(code);
            }
            break;
        }
        this.cdr.detectChanges();
      });
  }

  /**
   * update the promotioncode search to the next input
   * @param phrase input box value
   */
  searchPromocode(phrase: string) {
    const phrase_ = phrase.trim();

    if (this.promotionCode.value !== '' && phrase_.length) {
      this.promocodeSearching = true;
      this.promocodeService.updatePhrase(phrase_);
      this.cdr.detectChanges();
    } else {
      this.changedPromotionCode.emit('');
    }
  }
}
